export default __webpack_public_path__ + "static/media/dados-do-hotel.74730efb.svg";